module.exports = __webpack_public_path__ + "static/media/box1.f89c18fb.jpg";